// extracted by mini-css-extract-plugin
export var icon = "_4r-1";
export var subtext = "_4r-0";